import { registerPlugin } from '@capacitor/core';
export const CofreBiometrico = registerPlugin('CofreBiometrico', {
    web: () => ({
        disponivel: async () => ({ disponivel: false, tipo: null }),
        guardar: async () => { throw Object.assign(new Error('Sem cofre no navegador.'), { code: 'INDISPONIVEL' }); },
        ler: async () => { throw Object.assign(new Error('Sem cofre no navegador.'), { code: 'INDISPONIVEL' }); },
        apagar: async () => { },
        protegido: async () => ({ protegido: false }),
        confirmarDono: async () => { throw Object.assign(new Error('Sem cofre no navegador.'), { code: 'INDISPONIVEL' }); },
    }),
});
